import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeltonResourceManage = ({ count = 1, circle, ...rest }) => {
  return (
    <>
      <div className="sharemodalcont">
        {Array.from({ length: count }).map((_, index) => (
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2  pt-3">
              <Skeleton circle={circle} width={rest.width || 80} height={rest.height || 80} />
              <div>
                <h6 className="username m-0">
                  <Skeleton width="10rem" height="1rem" />
                </h6>
                <p className="usermail m-0">
                  <Skeleton width="10rem" height="0.85rem" />
                </p>
              </div>
            </div>
            <div>
              <Skeleton width="4rem" height="1.5rem" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SkeltonResourceManage;
